import { CompRef } from '@wix/document-services-types';
import { StyleNamespace } from '../../../apis/services/editActionsServices/nativeActions/globalDesign/types';
import type { EditorPointer } from '@wix/editor-document-logic-api';

export const createStylesObject = <T>(namespace: StyleNamespace, value: T) => ({
  cssCustomProperties: {},
  cssProperties: {},
  [namespace]: value,
});

/**
 * Compares two editor pointers for equality by comparing their unique keys
 */
export const arePointersEqual = (
  pointer1: EditorPointer<CompRef>,
  pointer2: EditorPointer<CompRef>,
): boolean => {
  return pointer1.asUniqueKey === pointer2.asUniqueKey;
};
